import i18n from "@mirage/translations";

import type {
  ContentCacheError,
  ContentCacheLoaded,
} from "@mirage/mosaics/Chat/data/ComposeSourcesCache";
import type { ChatSourceTransient } from "@mirage/mosaics/Chat/types";
import type { ComposeAssistantConversationMessage } from "@mirage/shared/compose/assist-message";
import { getSourceTitle } from "@mirage/shared/compose/compose-session";

/**
 * Transient sources represent sources that are not persisted + may be constantly changing. e.g.
 * this may be a browser tab that the Assistant is interacting with.
 */
export interface TransientSource {
  source: ChatSourceTransient;
  getContent: () => Promise<ContentCacheLoaded | ContentCacheError>;
}

export function createTransientSourceMessage(
  transientSource: TransientSource,
): ComposeAssistantConversationMessage {
  const source = transientSource.source;
  const title =
    getSourceTitle(source) ||
    i18n.t("compose_assistant_message_transient_source_generic_title");
  return {
    type: "message",
    role: "assistant",
    text: i18n.t("compose_assistant_message_transient_sources", {
      title,
    }),
    ts: Date.now(),
    referencingSources: [source],
    actionContext: {
      type: "read_current_browser_tab",
      sourceTitle: title,
    },
  };
}
